import { render, staticRenderFns } from "./HomeWelcome.vue?vue&type=template&id=30012b30&"
import script from "./HomeWelcome.vue?vue&type=script&lang=js&"
export * from "./HomeWelcome.vue?vue&type=script&lang=js&"
import style0 from "./HomeWelcome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports